import { Button, Col, Input, Modal, Row, Space, Table } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import toaster from 'helper/toaster';
import DashboardContext from 'Context';
import Excel from 'components/table/excel';
import Switchrs from 'components/inputs/Switchrs';
import FileUploader from 'components/fileUploader';
import { Dropdown, InputGroup } from 'react-bootstrap';
import ModalDelete from 'components/tabel/ModalDelete';
import InputControl from 'components/inputs/InputControl';
import InputPricing from 'components/inputs/InputPricing';
import CustomPagination from 'components/table/pagination';
import InputControlMulti from 'components/inputs/InputControlMulti';
import InputFarsi from 'components/inputs/InputFarsi';

export default function Advertisement() {
  const { urldashboard, authentication, accessPage, handelerrors } =
    useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState('');
  const [record, setRecord] = useState({});
  const [headers, setHeaders] = useState([]);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [formModal, setFormModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    if (!formModal && !deleteModal) {
      getAds({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
      });
      setRecord({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formModal, deleteModal]);

  const getAds = async ({ page, pageSize, searchValue }) => {
    setLoading(true);
    try {
      let url = '/advertisement/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getAds({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
    });
  };

  const search = () => {
    getAds({
      page: 1,
      pageSize: 10,
      searchValue,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            {/* <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() => handleDelete(record?.id)}
            >
              حذف
            </Dropdown.Item> */}
            <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() => handleEdit(record?.id)}
            >
              ویرایش
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'عنوان',
      dataIndex: 'title',
      key: 'title',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'نام شرکت',
      dataIndex: 'compnayName',
      key: 'compnayName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'ناحیه',
      dataIndex: 'districtName',
      key: 'districtName',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'جنسیت',
      dataIndex: 'gender',
      key: 'gender',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'حقوق (ریال)',
      dataIndex: 'salary',
      key: 'salary',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ? value.toLocaleString() : '-'}</span>,
    },
    {
      title: 'اولویت',
      dataIndex: 'isTop',
      key: 'isTop',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
    {
      title: 'وضعیت',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <span>
          {value ? (
            <i
              className='mdi mdi-check'
              style={{ color: 'green', fontSize: '1.5rem' }}
            ></i>
          ) : (
            <i
              className='mdi mdi-close'
              style={{ color: 'red', fontSize: '1.5rem' }}
            ></i>
          )}
        </span>
      ),
    },
  ];

  // actions

  const handleEdit = async (id) => {
    setIsEditing(true);
    setRowId(id);
    try {
      let url = `/advertisement/update/${id}`;
      const response = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data?.data;
      setRecord(data);
      setFormModal(true);
    } catch (error) {
      handelerrors(error);
    }
  };

  const handleDelete = (id) => {
    setRowId(id);
    setDeleteModal(true);
  };

  const submit = async () => {
    setSubmitLoading(true);

    try {
      let url = isEditing ? '/advertisement/update' : '/advertisement/create';

      const editCommand = {
        ...record,
        ...formData,
        id: rowId,
      };

      const response = isEditing
        ? await Axios.put(urldashboard + url, editCommand, {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json; charset=utf-8',
            },
          })
        : await Axios.post(urldashboard + url, formData, {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json; charset=utf-8',
            },
          });
      toaster.success(response?.data?.message);
      setSubmitLoading(false);
      setRecord({});
      setRowId('');
      setIsEditing(false);
      setFormModal(false);
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
      setRecord({});
      setRowId('');
      setIsEditing(false);
      setFormModal(false);
    }
  };

  return (
    <>
      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <InputGroup>
            <Input
              placeholder='جستجوی سریع (عنوان گروه)'
              name='searchValue'
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                height: '3rem',
                width: '90%',
                display: 'table-cell',
              }}
            />
            <Button
              onClick={search}
              style={{
                height: '3rem',
                width: '10%',
                display: 'table-cell',
                padding: 0,
              }}
            >
              <i className='mdi mdi-magnify'></i>
            </Button>
          </InputGroup>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Excel data={data} headers={headers} fileName={'آگهی‌ها'} />
            <Button
              block
              onClick={() => setFormModal(true)}
              style={{ height: '3rem' }}
              type='primary'
              className='btn btn-primary border border-secondary rounded-0'
            >
              افزودن
              <i className='mdi mdi-plus mr-2'></i>
            </Button>
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      {deleteModal && (
        <ModalDelete
          showitem={deleteModal}
          handleCloseMoudal={() => setDeleteModal(false)}
          handeldeleteModal={() => setDeleteModal(false)}
          id={rowId}
        />
      )}

      {formModal && (
        <Modal
          title={isEditing ? 'ویرایش آگهی' : 'افزودن آگهی'}
          open={formModal}
          width={1500}
          onCancel={() => {
            setRecord({});
            setIsEditing(false);
            setFormModal(false);
          }}
          closable={false}
          footer={[
            <Button
              block
              key='submit'
              loading={submitLoading}
              onClick={() => submit()}
              className='btn btn-primary rounded-0'
            >
              ثبت
            </Button>,
          ]}
        >
          <Row gutter={20}>
            <Col span={24}>
              <InputFarsi
                name='title'
                label='عنوان'
                defaultValue={record?.title}
                handelValue={(_, value) =>
                  setFormData({ ...formData, title: value })
                }
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
              <InputControl
                url='/businessCompany/getDropdown'
                label='شرکت'
                name='companyId'
                defaultValue={record?.companyId}
                handelValue={(_, value) =>
                  setFormData({ ...formData, companyId: value })
                }
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
              <InputControl
                label='نوع زیرسیستم'
                name='profileBusinessType'
                url='/common/getSubSystemType'
                defaultValue={record?.profileBusinessType}
                handelValue={(_, value) =>
                  setFormData({ ...formData, profileBusinessType: value })
                }
              />
            </Col>
            {((formData?.profileBusinessType !== null &&
              formData?.profileBusinessType !== undefined) ||
              (record?.profileBusinessType !== null &&
                record?.profileBusinessType !== undefined)) && (
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <InputControl
                  name='categoryId'
                  label='نوع خدمت'
                  defaultValue={record?.categoryId}
                  url={`/category/dropdown/${
                    formData?.profileBusinessType !== null &&
                    formData?.profileBusinessType !== undefined
                      ? formData?.profileBusinessType
                      : record?.profileBusinessType
                  }`}
                  handelValue={(_, value) =>
                    setFormData({ ...formData, categoryId: value })
                  }
                />
              </Col>
            )}
            {((formData?.categoryId !== null &&
              formData?.categoryId !== undefined) ||
              (record?.categoryId !== null &&
                record?.categoryId !== undefined)) && (
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <InputControlMulti
                  name='groupIds'
                  label='نوع زیر خدمت'
                  defaultValue={record?.groupIds}
                  url={`/group/groupDropdown/${
                    formData?.categoryId !== null &&
                    formData?.categoryId !== undefined
                      ? formData?.categoryId
                      : record?.categoryId
                  }/true`}
                  handelValue={(_, value) =>
                    setFormData({ ...formData, groupIds: value })
                  }
                />
              </Col>
            )}
          </Row>
          <Row gutter={20}>
            <Col span={24}>
              <FileUploader
                isBase64
                maxFiles={1}
                label={'بنر آگهی'}
                setFile={(value) =>
                  setFormData({ ...formData, pictureFile: value })
                }
              />
            </Col>
          </Row>
          <Row gutter={20}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <InputPricing
                label='حقوق'
                name='salary'
                value={formData?.salary}
                defaultValue={record?.salary}
                handelValue={(_, value) =>
                  setFormData({ ...formData, salary: value })
                }
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <InputControl
                name='gender'
                label='جنسیت'
                url='/common/genderDropdown'
                defaultValue={record?.gender}
                handelValue={(_, value) =>
                  setFormData({ ...formData, gender: value })
                }
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <InputControl
                url='/district/dropdown'
                label='ناحیه'
                name='districtId'
                defaultValue={record?.districtId}
                handelValue={(_, value) =>
                  setFormData({ ...formData, districtId: value })
                }
              />
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={24}>
              <div className='form-group'>
                <label htmlFor='description' style={{ fontSize: '15px' }}>
                  متن آگهی
                </label>
                <textarea
                  className='form-control'
                  id='description'
                  rows='6'
                  defaultValue={record?.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  style={{ borderWidth: '2px' }}
                ></textarea>
              </div>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={12}>
              <Switchrs
                name='isActive'
                label='آیا فعال باشد؟'
                defaultChecked={record?.isActive}
                handelValue={(_, value) =>
                  setFormData({ ...formData, isActive: value })
                }
              />
            </Col>
            <Col span={12}>
              <Switchrs
                name='isTop'
                defaultChecked={record?.isTop}
                label='آیا آگهی در بالا باشد؟'
                handelValue={(_, value) =>
                  setFormData({ ...formData, isTop: value })
                }
              />
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
}
